import { Image, StyleSheet, View, useWindowDimensions } from 'react-native';
import { Platform } from 'utils/platform';

import appStoreBadge from 'assets/app-store-badge.png';
import googlePlayBadge from 'assets/google-play-badge.png';

const STORES = [
  {
    label: 'Baixar Bandplay na App Store',
    url: 'https://apps.apple.com/br/app/bandplay-band-filmes-e/id710693911',
    badge: appStoreBadge,
  },
  {
    label: 'Baixar Bandplay no Google Play',
    url: 'https://play.google.com/store/apps/details?id=br.com.band.guiatv&pli=1',
    badge: googlePlayBadge,
  },
];

const StoreLinks = () => {
  const { width } = useWindowDimensions();
  const badgeWidth = width < 950 ? 160 : 200;

  if (Platform.isTV) {
    return null;
  }

  return (
    <View style={styles.stores}>
      {STORES.map(({ label, url, badge }) => (
        <a
          key={url}
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={`${label} (abre em nova aba)`}
          style={{ display: 'block', borderRadius: 32 }}>
          <Image
            source={badge}
            resizeMode="contain"
            style={{ width: badgeWidth, height: badgeWidth / 2.87 }}
          />
        </a>
      ))}
    </View>
  );
};

const styles = StyleSheet.create({
  stores: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'center',
    gap: 16,
    maxWidth: '100%',
    marginBottom: 32,
  },
});

export default StoreLinks;
